(function($){
    $.PrefetchContent = function(options) {
        this._component_name = "prefetch_content";
        this._loaded = [];
        this._on('ready', $.Component.bind(this, $.PrefetchContent));
    };

    $.Component.create($.PrefetchContent, {
        _init_: function(options) {
            this._options = options || {};
            this._urls = this._options.urls || [];
            this._loaded = []; 

            this.download();
        },

        download: async function() {
            let promises = [];
            for (const url of this._urls) {
                promises.push(fetch(url));
            }
 
            let settled = await Promise.allSettled(promises);
            for (const p of settled) {
                if (p.status === "fulfilled") {
                    const response = p.value; 

                    const div = document.createElement('div');
                    div.innerHTML = await response.text();

                    for ( ; div.children.length > 0; ) {
                        var child_element = div.children[div.children.length - 1];
                        document.body.appendChild(child_element);
                    } 

                    if (typeof(abdo_osd) !== "undefined") {
                        abdo_osd.addCache(response.url);
                    }
                }
            }
            this._emit('ready');
        }, 
    }, $.OSD); 

})(ABDOMap);